<template>
	<div class="update">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">数据修改  </h2>
		
		<div class="search" @keyup.enter="query">
			<el-input
				v-model="reportCode"
				class="qjc-fts-14"
				placeholder="请输入报告编码"
				onkeyup="value=value.replace(/[^\d]/g,'')"
				:disabled="noQuery"
			></el-input>
			<el-button @click="query" :disabled="noQuery" :loading="submiting" class="qjc-fts-16">查询</el-button>
		</div>
		
		<!-- 根据type判断录入还是修改 -->
		<data-template type="update" :clearData="clearData"  :formData="formData" :reportCode="reportCode" @stopQuery="stopQuery"></data-template>
		
	</div>
</template>

<script>
	import DataTemplate from '@/components/DataTemplate';
	import { dataQuery } from '@/utils/axios.js'
	
	export default{
		name: 'dataUpdate',
		data() {
			return {
				submiting: false,// 正在请求
				
				noQuery: false,// 禁止查询
				
				reportCode: '',// 查询报告编码
				
				formData: {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],//默认基础套餐
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: '',// 当前后台操作人手机号
					
					report_code: ''// 报告编码(数据修改必须)
				}// 数据存储
			}
		},
		components: {
			DataTemplate
		},
		methods: {
			clearData() {
				this.reportCode = '';
				this.noQuery = false;
				this.formData = {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],//默认基础套餐
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: '',// 当前后台操作人手机号
					
					report_code: ''// 报告编码(数据修改必须)
				}
			},
			query() {
				if(this.reportCode){
					// 正在请求
					this.submiting == true;
				
					dataQuery({
						report_code: this.reportCode
					}).then(res => {
						// 请求成功
						this.submiting == false;
						
						if(res.code == 200){
							this.formData.report_code = this.reportCode;
							
							Object.assign(this.formData, res.data);
						}else{
							this.$myAlert({
								type: 'fail',
								content: res.msg
							});
						}
					})
				}else{
					this.$myAlert({
						title: '报告编码不能为空'
					});
				}
			},
			
			//禁止再次查询
			stopQuery() {
				this.noQuery = true;
			}
		}
	}
</script>

<style scoped>
	.search >>> .el-input__inner{
		height: 0.36rem;
		line-height: 0.14rem;
		font-size: 0.14rem;
		padding: 0.1rem 0.12rem;
		background-color: #FAFBFC;
	}
</style>
<style lang="scss" scoped>
	.update{
		.search{
			margin-top: 0.32rem;
			
			.el-input{
				width: 5.05rem;
			}
			.el-button{
				width: 0.72rem;
				height: 0.36rem;
				line-height: 0.36rem;
				font-size: 0.15rem;
				padding: 0;
				margin-left: 0.16rem;
			}
		}
	}
</style>